/**
 * The financial year a new Indian company is trading in: April to March, named "2026-27".
 *
 * Computed from the calendar date by hand rather than through a date library's locale, for the
 * reason the morning screen computes its week by hand — what a library thinks a year starts on is a
 * setting, and here the answer is the law. A date in January to March belongs to the year that began
 * the previous April.
 */
export interface FinancialYearSuggestion {
  code: string;
  startDate: string;
  endDate: string;
}

export function suggestFinancialYear(today: Date): FinancialYearSuggestion {
  const year = today.getFullYear();
  const start = today.getMonth() >= 3 ? year : year - 1;
  const end = start + 1;

  return {
    code: `${start}-${String(end % 100).padStart(2, '0')}`,
    startDate: `${start}-04-01`,
    endDate: `${end}-03-31`,
  };
}
